import { useMutation } from '@tanstack/react-query';

import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { SessionPrepInfo } from 'features/sessions/config/types';
import { useSessionsQueryActions } from 'features/sessions/hooks/useSessionsQueryActions';
import { mapNextSessionPostData } from 'features/sessions/utils';

export const useNextSessionUpdateMutation = (sessionId: string) => {
  const { request } = useMutationHTTPRequest();

  const { updateSession } = useSessionsQueryActions();

  return useMutation(
    (session: SessionPrepInfo) =>
      request({
        url: `/api/coach/coaching-sessions/${sessionId}/update-prep-info`,
        body: mapNextSessionPostData(session),
      }),
    {
      onSuccess: (newSessionPrepInfo: SessionPrepInfo) => {
        updateSession(sessionId, {
          nextSessionAppointment: newSessionPrepInfo.nextSessionAppointment,
        });
      },
      onError: (e) => {
        logError(e);
      },
    }
  );
};
